import React from 'react';

import styled from 'styled-components';

import LogoPurple from 'components/no-auth/header/LogoPurple';

import promoColors from 'theme/promoColors';

const LogoContainer = styled.div`
    width: 116px;
    margin-bottom: 32px;

    svg path {
        fill: ${promoColors.gray80};
    }

    &:hover svg path {
        fill: ${promoColors.gray40};
    }
`;

export default function FooterLogo(props) {
    return (
        <LogoContainer>
            <LogoPurple lang={props.lang} country={props.country} />
        </LogoContainer>
    );
}
